import { render, staticRenderFns } from "./mapMarked.vue?vue&type=template&id=2eddf7ef&scoped=true"
import script from "./mapMarked.vue?vue&type=script&lang=js"
export * from "./mapMarked.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eddf7ef",
  null
  
)

export default component.exports